import { useQuery } from '@tanstack/react-query'
import { useAuthStore } from '@turnifly/shared/stores'
import { fetchPomodoroStats } from '@turnifly/shared/api'
import type { PomodoroStats } from '@turnifly/shared/types'

const statsKeys = {
  stats: (uid: string) => ['pomodoro', 'stats', uid] as const,
}

export function usePomodoroStats(): {
  stats: PomodoroStats | undefined
  isLoading: boolean
} {
  const userId = useAuthStore((s) => s.user?.id) ?? ''

  const { data, isLoading } = useQuery({
    queryKey: statsKeys.stats(userId),
    queryFn: () => fetchPomodoroStats(userId),
    enabled: !!userId,
    staleTime: 60_000,
  })

  return { stats: data, isLoading }
}
